import { render, staticRenderFns } from "./BarcodeCard.vue?vue&type=template&id=dfd7a618&"
import script from "./BarcodeCard.vue?vue&type=script&lang=ts&"
export * from "./BarcodeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports